'use strict';
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dTransaction from "./com.raquo.airstream.core.-Transaction.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$2(f$2, outer) {
  this.GZ = null;
  this.GZ = f$2;
  if ((outer === null)) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_NullPointerException__(new $j_java$002elang$002e$002dObject.$c_jl_NullPointerException());
  }
}
export { $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$2 as $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$2 };
$p = $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$2.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$2;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_Modifier$$anon$2() {
}
export { $h_Lcom_raquo_laminar_modifiers_Modifier$$anon$2 as $h_Lcom_raquo_laminar_modifiers_Modifier$$anon$2 };
$h_Lcom_raquo_laminar_modifiers_Modifier$$anon$2.prototype = $p;
$p.dL = (function(element) {
  var this$2 = $j_com$002eraquo$002eairstream$002ecore$002e$002dTransaction.$m_Lcom_raquo_airstream_core_Transaction$onStart$();
  var f = (() => {
    this.GZ.j(element);
  });
  $j_com$002eraquo$002eairstream$002ecore$002e$002dTransaction.$m_Lcom_raquo_airstream_core_Transaction$onStart$();
  var when = true;
  if ((this$2.cG || (!when))) {
    f();
  } else {
    this$2.cG = true;
    try {
      f();
    } finally {
      this$2.cG = false;
      $j_com$002eraquo$002eairstream$002ecore$002e$002dTransaction.$p_Lcom_raquo_airstream_core_Transaction$onStart$__resolve__V(this$2);
    }
  }
});
var $d_Lcom_raquo_laminar_modifiers_Modifier$$anon$2 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_modifiers_Modifier$$anon$2, "com.raquo.laminar.modifiers.Modifier$$anon$2", ({
  iy: 1,
  ab: 1
}));
export { $d_Lcom_raquo_laminar_modifiers_Modifier$$anon$2 as $d_Lcom_raquo_laminar_modifiers_Modifier$$anon$2 };
